var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{style:(_vm.types[_vm.status]),attrs:{"rounded":""},on:{"click":function($event){return _vm.share()}}},[_vm._v("\n  "+_vm._s(_vm.btnLabel)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }